// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4312c695","977":"4de1a70f"}[chunkId] + ".chunk.js";
};